import { useEffect, useState } from 'react';

import { getComponentFormError } from '@dec/shared';
import { type CatalogModel } from 'app/modules/Parameters/Catalog/Catalog/types';
import Env from 'env';
import Leaflet, * as L from 'leaflet';
import { Form } from 'react-bootstrap';
import { Controller, useFormContext } from 'react-hook-form';
import { MapContainer, Marker, TileLayer, useMapEvent } from 'react-leaflet';

import 'leaflet/dist/leaflet.css';

//import image from '../../../../../public/images/marker-icon.png';
Leaflet.Icon.Default.imagePath = '../node_modules/leaflet';

const icon = L.icon({
  iconUrl: `${Env.publicUrl}/images/marker-icon.png`,
  shadowUrl: `${Env.publicUrl}/images/marker-icon.png`,
  iconSize: [25, 41],
  iconAnchor: [25, 41]
});
interface Props {
  label: string;
  name: string;
  defaultValue?: any;
  whenChange?: (selected: any) => void;
  readOnly?: boolean;
  country?: CatalogModel;
}

interface LatLng {
  latitude: string;
  longitude: string;
}

function getLatitudeLongitude(country?: CatalogModel): L.LatLng {
  let result = new L.LatLng(9.0148503, -79.538128);
  if (country && country.additionalFields) {
    const { latitude, longitude }: LatLng = country.additionalFields;

    if (latitude && !isNaN(latitude as any) && longitude && !isNaN(longitude as any)) {
      result = new L.LatLng(parseFloat(latitude), parseFloat(longitude));
    }
  }

  return result;
}

function GeoMarker(props: Props) {
  const {
    register,
    formState: { errors },
    setValue,
    control,
    watch
  } = useFormContext();
  const { label, name, defaultValue, whenChange, readOnly, country } = props;
  const [map, setMap] = useState<L.Map>();
  const countryLatitudeLongitude = getLatitudeLongitude(country);
  const [markers, setmarkers] = useState<Array<L.LatLng>>([countryLatitudeLongitude]);

  const currentValue = watch(name);
  const error = getComponentFormError(name, errors);
  const addMarker = (e: any) => {
    setmarkers([e.latlng]);
    setValue(name, e.latlng);
    if (whenChange) {
      whenChange(e.latlng);
    }
  };

  const setDefaults = () => {
    const value = defaultValue ? [new L.LatLng(defaultValue.lat, defaultValue.lng)] : [];
    setmarkers(value);
    setValue(name, value.length > 0 ? value[0] : null);
    defaultValue && map && map.panTo(value[0]);
  };

  const MyComponent = () => {
    const map = useMapEvent('click', (e: any) => {
      if (!readOnly) {
        addMarker(e);
        map && map.panTo(e.latlng);
      }
    });
    return null;
  };

  useEffect(() => {
    map && map.setView(getLatitudeLongitude(country), 8);
  }, [country]);

  useEffect(() => {
    setDefaults();
  }, [defaultValue]);

  useEffect(() => {
    if (!currentValue) {
      setmarkers([]);
    }
  }, [currentValue]);

  return (
    <>
      <Form.Label>{label}</Form.Label>
      <Controller
        defaultValue={markers}
        name={name}
        render={({ field }) => {
          return (
            <MapContainer
              center={currentValue ?? countryLatitudeLongitude}
              ref={setMap as any}
              zoom={8}
            >
              <MyComponent />
              <TileLayer
                attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
              />
              {markers.map((position: any, idx: any) => {
                return (
                  <Marker icon={icon} key={`marker-${idx}`} position={position}>
                    {/*<Popup>
                      <span>Digital economy</span>
                    </Popup>*/}
                  </Marker>
                );
              })}
            </MapContainer>
          );
        }}
        control={control}
      />
      <div className="invalid-feedback d-block">{error ? error.message : ''}</div>
    </>
  );
}
export default GeoMarker;
